<template>
    <div class="jump-warphd nav-bar-fixed">
        <van-nav-bar title="我的评价" left-arrow fixed
                     @click-left="back"/>
        <div class="comt-item" v-for="item in order.goodsList">
            <p class="comt-title">评价商品</p>
            <van-row class="good-item">
                <van-col span="8">
                    <img :src="item.picUrl"/>
                </van-col>
                <van-col span="16">
                    <!--<p><span>店铺名:</span>{{item.}}</p>-->
                    <p style="margin-top: 5px"><span>商品名称:</span>{{item.goodsName}}</p>
                    <p style="margin-top: 5px"><span>商品数量:</span>{{item.goodsCount}}</p>
                    <p style="margin-top: 5px"><span>价格:</span><span class="red">{{item.price}}</span></p>
                </van-col>
            </van-row>
            <p class="comt-title">我的评价</p>
            <div class="comt-foot">
                <!-- <van-cell title="评价类型" is-link arrow-direction="down" value="质量好"/>-->
                <van-field
                        v-model="istruegg[item.id]"
                        readonly
                        label="评价类型"
                        placeholder="请选择"
                        @focus="showPop(item.id)"
                />

                <van-row>
                    <van-col span="6">
                        <p>描述相符</p>
                    </van-col>
                    <van-col span="12">
                        <!--<div><span style="width:100%"></span></div>-->
                        <van-rate
                                v-model="ms[item.id]"
                                :size="25"
                                color="#f44"
                                void-icon="star"
                                void-color="#eee"
                        />
                    </van-col>
                    <van-col span="6">
                        <p class="text-right">非常满意</p>
                    </van-col>
                </van-row>
                <van-row>
                    <van-col span="6">
                        <p>服务态度</p>
                    </van-col>
                    <van-col span="12">
                        <!--<div><span></span></div>-->
                        <van-rate
                                v-model="fw[item.id]"
                                :size="25"evaluateOrderSave
                                color="#f44"
                                void-icon="star"
                                void-color="#eee"
                        />
                    </van-col>
                    <van-col span="6">
                        <p class="text-right">很满意</p>
                    </van-col>
                </van-row>
                <van-row>
                    <van-col span="6">
                        <p>发货速度</p>
                    </van-col>
                    <van-col span="12">
                        <!--<div><span style="width:100%"></span></div>-->
                        <van-rate
                                v-model="fh[item.id]"
                                :size="25"
                                color="#f44"
                                void-icon="star"
                                void-color="#eee"
                        />
                    </van-col>
                    <van-col span="6">
                        <p class="text-right">非常满意</p>
                    </van-col>
                </van-row>
                <p class="comt-rad text-center">
                    <van-radio-group v-model="resId[item.id]" class="text-center">
                        <van-radio name="1">好评(加1分)</van-radio>
                        <van-radio name="0">中评(不加分)</van-radio>
                        <van-radio name="-1">差评(减1分)</van-radio>
                    </van-radio-group>
                </p>
                <p class="comt-des">
                    评价后不可更改，请您根据本次交易，给予真实、客观、仔细地评价。您的评价将是其他卖家的参考，也将影响卖家的信用。
                </p>
                <van-field type="textarea" v-model="conetent[item.id]"/>
            </div>
        </div>

        <van-row class="jump-warphd-foot">
            <van-col span="12">
                <van-button size="large" @click="fanhui">返 回</van-button>
            </van-col>
            <van-col span="12">
                <van-button size="large" @click="save">确 定</van-button>
            </van-col>
        </van-row>


        <van-popup v-model="popShow" position="bottom" :overlay="true">
            <van-picker
                    :columns="columns"
                    show-toolbar
                    @cancel="onPickerCancel"
                    @confirm="onPickerConfirm"
                    @change="onPickerChange"
            />
        </van-popup>
    </div>
</template>
<script>
    import {NavBar, Cell, CellGroup, Field, Button, Row, Col, Radio, RadioGroup, Rate, Picker, Popup} from "vant";

    export default {
        name: "usercommentadd",
        components: {
            [NavBar.name]: NavBar,
            [CellGroup.name]: CellGroup,
            [Cell.name]: Cell,
            [Field.name]: Field,
            [Button.name]: Button,
            [Row.name]: Row,
            [Col.name]: Col,
            [Radio.name]: Radio,
            [Rate.name]: Rate,
            [Picker.name]: Picker,
            [Popup.name]: Popup,
            [RadioGroup.name]: RadioGroup
        },
        data() {
            return {
                bsid: '',
                ms: [],
                fw: [],
                fh: [],
                popShow: false,
                columns: [],
                resId: [],
                id: this.$route.query.id,
                order: {},
                orderType: [],
                conetent: [],
                istruegg: []
            };
        }, mounted: function () {
            this.getInfo()
        },
        methods: {
            onPickerCancel() {
                this.popShow = false;
            }, onPickerConfirm(values) {
                this.istruegg[this.bsid] = values;
                this.popShow = false;
            },
            onPickerChange(picker, values) {
                picker.setColumnValue(1, values);
            },
            showPop(id) {
                this.bsid = id
                this.popShow = true;
            },
            back() {
                history.back();
            }, getInfo() {
                let that = this
                //获取评价订单
                that.$api.get(
                    that.jumuc.order.getEvaluateOrder,
                    {"orderId": that.id},
                    successRes => {
                        that.order = successRes.data
                        for (var i = 0; i < that.order.goodsList.length; i++) {
                            that.ms[that.order.goodsList[i].id] = 5
                            that.fw[that.order.goodsList[i].id] = 5
                            that.fh[that.order.goodsList[i].id] = 5
                            that.resId[that.order.goodsList[i].id] = '1'
                        }
                        //获取评价订单类型
                        that.$api.get(
                            that.jumuc.order.getEvaluateType,
                            null,
                            successRes => {
                                that.orderType = successRes.data
                                for (var i = 0; i < successRes.data.length; i++) {
                                    that.columns[i] = successRes.data[i].dictdataValue
                                    if(i==0){
                                        that.istruegg=[]
                                        that.istruegg[that.order.goodsList[0].id] = successRes.data[0].dictdataValue;
                                    }
                                }
                            }
                        )

                    }
                )
            }, fanhui() {
                this.$router.push({
                    path: '/user/order',
                })
            }, save() {
                let that = this
                let json = {"orderId": that.id}
                for (var i = 0; i < that.order.goodsList.length; i++) {
                    let typeId = null
                    for (var j = 0; j < that.orderType.length; j++) {
                        if (that.istruegg[that.order.goodsList[i].id] == that.orderType[j].dictdataValue) {
                            typeId = that.orderType[j].id
                        }
                    }
                    json['resText' + that.order.goodsList[i].id] = typeId
                    json['description_evaluate' + that.order.goodsList[i].id] = that.ms[that.order.goodsList[i].id]
                    json['ship_evaluate' + that.order.goodsList[i].id] = that.fh[that.order.goodsList[i].id]
                    json['service_evaluate' + that.order.goodsList[i].id] = that.fw[that.order.goodsList[i].id]
                    json['evaluate_buyer_val' + that.order.goodsList[i].id] = that.resId[that.order.goodsList[i].id]
                    json['evaluate_info_' + that.order.goodsList[i].id] = that.conetent[that.order.goodsList[i].id]
                }
                that.$api.post(
                    that.jumuc.order.evaluateOrderSave,
                    json,
                    successRes => {
                        if (successRes.success) {
                            this.$router.push({
                                path: '/user/order'
                            })
                        } else {
                            that.$toast(successRes.msg)
                        }
                    }
                )
            }
        }
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3c6eeb;

    .jump-warphd {
        padding-bottom: 20px;
        .comt-item {
            .comt-title {
                border-bottom: 1px solid #f7f7f7;
                color: @bule-thame;
                font-size: 16px;
                line-height: 30px;
                padding: 10px;
            }
        }
        .good-item {
            border-bottom: 1px solid #f7f7f7;
            padding: 10px;
            img {
                width: 100%;
            }
            p {
                font-size: 14px;
                line-height: 24px;
                span {
                    display: inline-block;
                    min-width: 60px;
                    margin-right: 5px;
                }
            }
        }
        .comt-item:not(:last-child)::after {
            border-bottom: 1px solid #f7f7f7;
        }
        .comt-foot {
            padding: 0 10px;
            p {
                font-size: 14px;
                line-height: 40px;
            }

            .comt-des {
                line-height: 24px;
                color: @bule-thame;
            }
        }
        .comt-step {
            padding: 10px 0;
            div {
                border: 1px solid @bule-thame;
                border-radius: 20px;
                height: 20px;
            }
            span {
                padding: 10px;
                background-color: @bule-thame;
                border-radius: 20px;
                display: inline-block;
                width: 80%;
            }
        }
        .van-cell {
            padding: 10px 0;
            .van-cell__value,
            .van-icon {
                color: @bule-thame;
            }
        }
        .van-radio {
            display: inline-block;
            margin: 0 5px;
            font-size: 14px;
        }
        /*.van-field {
            padding: 10px;
            border: 1px solid #f7f7f7;
        }*/

        &-foot {
            border-top: 1px solid #f7f7f7;
            padding: 10px 15px;
            font-size: 14px;
            .van-col--12 {
                padding: 0 10px;
            }
            button {
                background-color: @bule-thame;
                color: white;
                font-weight: 700;
                border-radius: 15px;
                margin: 25px 0 10px;
            }
        }
    }
</style>
